// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card__new-banner[data-v-1b0f9192]{--tw-bg-opacity:0.5;--tw-text-opacity:1;background-color:rgba(236,101,162,.5);color:#fff;color:rgb(255 255 255/var(--tw-text-opacity));font-size:.75rem;font-weight:700;left:0;line-height:1;padding:.25rem;position:absolute;right:0;text-align:center;top:0;transition-duration:.5s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
